import React from 'react';
import './OmniChannel.css';
import OmniChannelPicture from '../../images/omni.jpg';
import Header from "../../Header/Header";
import ussd from "../../images/omni-channel/ussd.png";
import sms from "../../images/omni-channel/sms.png";
import app from "../../images/omni-channel/app.png";
import web from "../../images/omni-channel/web.png";
import HeroSection from '../../Components/HeroSection/HeroSection';
import { Container } from 'bootstrap-4-react';
import { BrowserRouter as Router, Link } from "react-router-dom";
import Tada from 'react-reveal/Tada';
import Swing from 'react-reveal/Swing';
import Pulse from 'react-reveal/Pulse';
import {Tabs, Tab } from "react-bootstrap";
import { animateScroll as scroll} from 'react-scroll';
import Footer from '../../Footer/Footer';
import ReactGA from 'react-ga';

class OmniChannel extends React.Component{
    constructor() {
        super();
        this.state = {
            key:1,
            app:1,
            sms:1,
            web:1,
            ussd:1,
            loading: false,
            WindowSize : window.innerWidth,
        }
        this.reachScroll = React.createRef()
        this.handleSelect = this.handleSelect.bind(this);
    }
    
    scrollTo() {
        scroll.scrollTo(1000, {delay: 1000});
      }
    componentDidMount() {
          ReactGA.pageview('/omni-channel/');
          window.scrollTo(0, 0);
    }
    handleSelect(key, e) {
        this.setState({loading: true});
        setTimeout(() => { 
            this.setState(() => ({loading: false}),
            this.setState({key})
            )
        }, 1000);
        switch(key) {
            case 1 :
            this.setState({ ussd: this.state.ussd + 1 });
            break;
            case 2 :
            this.setState({ sms: this.state.sms + 1 });
            break;
            case 3 :
            this.setState({ app: this.state.app + 1 });
            break;
            case 4 :
            this.setState({ web: this.state.web + 1 });
            break;
        }
        if (this.state.WindowSize < 991) {
            this.scrollTo();
        }
    }
    
    render() {
        let loader = '';
       if (this.state.loading === true) {
            loader = <div className="loader-container">
                <i className="fa fa-spinner fa-spin"></i>
            </div>
       }
        return (
            <div className="solution-page omni-channel">
                <Header />
                <HeroSection pageTitle="Solutions" background={OmniChannelPicture} />
                <section className="page-content">
                    <Container>
                        <ul className="breadcrumbs">
                            <li><Link to="/">Homepage</Link></li>
                            <li><Link to="/omni-channel/" className="current">Omnichannel</Link></li>
                        </ul>
                    </Container>
                    <div className="solution-page-list">
                        <Container className="no-margin">
                            <div className="node-title">
                                <div></div>
                                <i className="fa fa-circle"></i>
                                <span> Omnichannel </span>
                                <i className="fa fa-circle"></i>
                                <div></div>
                            </div>
                            <div className="page-description-container">
                                <i className="fa fa-circle"></i>
                                <div className="page-description">
                                    <p>
                                        < b > Access anytime, anywhere, on any device. </b><br/ >
                                        Our omnichannel approach means your customers can access and pay
                                        for products and service on the channel of their choice: USSD, SMS, web or mobile app. Our omnichannel platforms offer many benefits including unique, branded customer experience across all operators,
                                            omnichannel digital point of sales for lottery games and betting,
                                            
                                            mobile customer account management,
                                            multiple languages (Swahili, English, French)
                                            and multiple payment methods like mobile money, direct carrier billing (airtime) and web payment page. <br/>

                                        Our portals and games are fully customizable to your brand and business requirements.
                                    </p>
                                </div>
                                <i className="fa fa-circle"></i>
                            </div>
                        </Container>
                    </div>
                    <Container className="omni-channel-container">
                    <div className="animation-container">
                        <div className="omni-products">
                            <div className="product ussd">
                                <Swing  spy={this.state.ussd}>
                                    <img src={ussd} onClick={()=>this.handleSelect(1)} />
                                </Swing>
                            </div>
                            <div className="product sms">
                                <Swing spy={this.state.sms}>
                                    <img src={sms} onClick={()=>this.handleSelect(2)}/>
                                </Swing>
                            </div>
                            <div className="product app">
                                <Tada spy={this.state.app}>
                                    <img src={app} onClick={()=>this.handleSelect(3)} />
                                </Tada>
                            </div>
                            <div className="product web">
                                <Pulse spy={this.state.web}>
                                    <img src={web} onClick={()=>this.handleSelect(4)}/>
                                </Pulse>
                            </div>
                        </div>
                        <div style={{clear:'both'}}></div>
                        
                        <div className="omni-tabs channel" >
                            {loader}
                            <Tabs ref={this.reachScroll} activeKey={this.state.key} onSelect={this.handleSelect} id="omni-tabs" className="omni-tabs-container">
                                <Tab eventKey={1} title="USSD">
                                Online, interactive and accessible everywhere by any kind of mobile phone and without the need of data connection, USSD (Unstructured Supplementary Service Data) is the most intuitive and convenient way to consume and pay
                                for services in the world’ s growth markets. Customers in Africa, where we have pioneered its development, use USSD
                                for a whole range of purposes inclusive of buying lottery tickets, placing bets, reading the news alongside many others.
                                </Tab>
                                <Tab eventKey={2} title="SMS">
                                Offline, interactive and accessible anywhere by any kind of mobile phone and without the need of data connection, this is another intuitive and convenient way to consume and pay
                                for services all over the world. We have a wealth of expertise on two-way SMS communications, SMS bulk marketing campaigns and creating SMS based games, polls and quizzes.
                                </Tab>
                                <Tab eventKey={3} title="APP">
                                With the constantly growing base of people connected to the internet and using smartphones, we have rolled out mobile applications to deliver multimedia rich content to users.
                                </Tab>
                                <Tab eventKey={4} title="WEB">
This is a growing way to consume multimedia rich content in the world’s growth markets. Our web products include online, interactive and state of the art lotteries, gaming sites and betting portals featuring player registrations, player game wallets and mobile money. We also offer online responsive premium subscription-based portals with exclusive multimedia articles and videos with secure mobile-network based login.
                                </Tab>
                            </Tabs>
                        </div>
                        </div>
                    </Container>
                </section>
                <Footer/>
            </div>
        );
    }
}
export default OmniChannel;
